module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6xaxL"))).then(() => parcelRequire('3a9aZ'));